<template>
  <v-row no-gutters justify="center">
    <v-col cols="auto" 
      v-for="(color, name) in colors"
      :key="name">
      <slot-button 
        :btnClass="buttonClass(color)"
        @click="$emit('input', color)"
        fab
        :small="!xSmall"
        :xSmall="xSmall"
        :btnColor="color"
        :color="color"
        :title="name"/>
    </v-col>
  </v-row>
</template>

<script>
import { ANNOTATION_COLORS } from "../../../config/config";
import slotButton from "../../controls/SlotButton";
export default {
  name: "annotationColorPicker",
  components: { slotButton },
  props: {
    value: String,
    size: {type: String, default: "small"}
  },
  data(){
    return {
      colors: ANNOTATION_COLORS
    }
  },
  computed: {
    xSmall() {
      return this.size == "xSmall";
    }
  },
  methods:{
    buttonClass(color){
      let btnClass = "rounded-button annotation-color-button " + this.colorClass;
      if (color === this.value) btnClass += " selected-color";
      return btnClass;
    }
  }
};
</script>
